// extracted by mini-css-extract-plugin
module.exports = {"dark":"WhereWeCanMeet_dark__2IHxD","imageHolder":"WhereWeCanMeet_imageHolder__2ad5k","textContainer":"WhereWeCanMeet_textContainer__1Vi_J"};